import { Fragment } from "react";
import { Link } from "react-router-dom";
import { BRAND, TEXT_LINK, type ContentLink } from "@neus/shared";
import { PHONE_HREF } from "../../nav";

/** A content link: a router link on the site, a new tab for another site; a button when its style says so. */
export function ContentLinkView({ link, className }: { link: ContentLink; className?: string }) {
  const cls = className ?? (link.style === "button" ? "btn" : link.style === "ghost" ? "btn btn--ghost" : undefined);
  if (link.to.startsWith("/"))
    return (
      <Link to={link.to} className={cls}>
        {link.label}
      </Link>
    );
  const external = /^https?:/.test(link.to) ? { target: "_blank", rel: "noreferrer" } : {};
  return (
    <a href={link.to} className={cls} {...external}>
      {link.label}
    </a>
  );
}

// {phone}, or a [label](href) link; split() keeps them at the odd indexes.
// (TEXT_LINK's own groups would add parts to the split, so this pattern has none inside.)
const TOKEN = /(\{phone\}|\[[^\]]+\]\([^)\s]+\))/;

/** Content text, with {phone} as a link to call and [label](/path) as a link. */
export function RichText({ text }: { text: string }) {
  return (
    <>
      {text.split(TOKEN).map((part, i) => {
        if (i % 2 === 0) return <Fragment key={i}>{part}</Fragment>;
        if (part === "{phone}")
          return (
            <a key={i} href={PHONE_HREF}>
              {BRAND.phone}
            </a>
          );
        const [, label, to] = [...part.matchAll(TEXT_LINK)][0]!;
        return <ContentLinkView key={i} link={{ label: label!, to: to! }} />;
      })}
    </>
  );
}

/** Paragraphs of content text. */
export const Paragraphs = ({ items }: { items: string[] }) =>
  items.map((p, i) => (
    <p key={i}>
      <RichText text={p} />
    </p>
  ));
